import React from "react";

const RightPerson = (props) => {
  const calculateAge = (date) => {
    const dateArr = date.split("/");
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();
    let ageValue = currentYear - dateArr[2];

    if (currentYear - dateArr[2] > 0) {
      if (currentMonth <= dateArr[1] && currentDay < dateArr[0]) {
        ageValue = ageValue - 1;
      }
    } else {
      ageValue = 0;
    }
    return ageValue;
  };
  return (
    <div className="rightPerson">
      <img className="rightPerson__image" src={props.image} />
      <p className="rightPerson__name">
        {props.name && props.name.toLowerCase().split(" ")[0]}
      </p>
      <p className="rightPerson__age">
        {props.birthday && calculateAge(props.birthday) + " años"}
      </p>
    </div>
  );
};
export default RightPerson;
